







































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Company } from "./Company";

@Component
export default class ResumeCompany extends Vue {
    @Prop() private company!: Company;

    private get hasSkills() {
        return Array.isArray(this.company.skills);
    }

    private get hasRoles() {
        return Array.isArray(this.company.roles);
    }
}
